import { useTranslation } from 'next-i18next'
import useConfig from 'modules/config/state/use-config'
import { UiIcon } from 'modules/ui/atoms/Icon'
import Column from 'modules/ui/atoms/Layout/Column'
import IconContainer from 'modules/ui/atoms/Layout/IconContainer'
import Row from 'modules/ui/atoms/Layout/Row'
import { Tooltip } from 'modules/ui/atoms/Tooltip'
import CheckboxField from 'modules/ui/molecules/FormComponents/CheckboxField'

const OrderAnonymousFields = () => {
  const { t } = useTranslation()
  const config = useConfig()

  return (
    <Column>
      {config.anonymous.isHideNameEnabled ? (
        <Row style={{ gap: 0 }}>
          <CheckboxField id="isNameAnonymous" dataId="contact-is-name-anonymous-checkbox">
            {t('OrderAnonymousFields.hideName.label', 'Hide my name from the public.')}
          </CheckboxField>
          <IconContainer top="2px">
            <Tooltip
              placement="top"
              text={t(
                'OrderAnonymousFields.hideName.tooltip',
                'Only the nonprofit will see your name so they can send receipts with tax information.',
              )}
            >
              <UiIcon name="info" color="#78726E" />
            </Tooltip>
          </IconContainer>
        </Row>
      ) : null}

      {config.anonymous.isHideAmountEnabled ? (
        <CheckboxField id="isAmountAnonymous" dataId="contact-is-amount-anonymous-checkbox">
          {t('OrderAnonymousFields.hideDonation.label', 'Hide my donation from the public.')}
        </CheckboxField>
      ) : null}
    </Column>
  )
}

export default OrderAnonymousFields
